import { render, staticRenderFns } from "./InvestInSheldonRealty.vue?vue&type=template&id=47e783c2&scoped=true&"
import script from "./InvestInSheldonRealty.vue?vue&type=script&lang=ts&"
export * from "./InvestInSheldonRealty.vue?vue&type=script&lang=ts&"
import style0 from "./InvestInSheldonRealty.vue?vue&type=style&index=0&id=47e783c2&scoped=true&lang=css&"
import style1 from "./InvestInSheldonRealty.vue?vue&type=style&index=1&id=47e783c2&scoped=true&lang=css&"
import style2 from "./InvestInSheldonRealty.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e783c2",
  null
  
)

export default component.exports